// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AssetTagSchema = z.enum(['REST','GRAPHQL','SOAP','AI','WEBSOCKET','GRPC','LOGIN','MFA','RESET_PASSWORD','OUT_OF_SCOPE','CRITICAL_TO_BUSINESS','BASIC_AUTH','USER_PERMISSIONS_ROLES','FILE_UPLOAD'] as const);

export type AssetTagType = `${z.infer<typeof AssetTagSchema>}`

export default AssetTagSchema;
